module.exports = __webpack_public_path__ + "img/bufentubiao_jishu-32.c645092a.png";